import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';
import { LogoutComponent } from './pages/auth/pages/signup/logout/logout.component';
import { setIsNewFlow } from './pages/auth/guards/set-is-new-flow.guard';
import { OperationsComponent } from './pages/transactions/operations/operations.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [setIsNewFlow],
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./pages/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [setIsNewFlow],
  },
  {
    path: 'support',
    loadChildren: () => import('./pages/public/public.module').then((m) => m.PublicModule),
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'operation',
    component: OperationsComponent,
  },
  { path: '', redirectTo: '/support', pathMatch: 'full' },
  { path: '**', redirectTo: 'onboarding' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
